import InstagramInstantwinAnalyticsPublicTabs from './InstagramInstantwinAnalyticsPublicTabs.vue'
export default InstagramInstantwinAnalyticsPublicTabs
